/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */
'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

require('babel/polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxCreate = require('./redux/create');

var _reduxCreate2 = _interopRequireDefault(_reduxCreate);

var _helpersApiClient = require('./helpers/ApiClient');

var _helpersApiClient2 = _interopRequireDefault(_helpersApiClient);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _scrollBehaviorLibUseStandardScroll = require('scroll-behavior/lib/useStandardScroll');

var _scrollBehaviorLibUseStandardScroll2 = _interopRequireDefault(_scrollBehaviorLibUseStandardScroll);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var client = new _helpersApiClient2['default']();
var history = _scrollBehaviorLibUseStandardScroll2['default'](function () {
  return _reactRouter.browserHistory;
})();
var dest = document.getElementById('app');
var store = _reduxCreate2['default'](history, client, window.__data);
var syncedHistory = _reactRouterRedux.syncHistoryWithStore(history, store);

_reactGa2['default'].initialize(_config2['default'].gaUa, {
  debug: __DEVELOPMENT__
});

function logPageView() {
  _reactGa2['default'].set({ page: window.location.pathname });
  _reactGa2['default'].pageview(window.location.pathname);
}

var component = _react2['default'].createElement(
  _reactRouter.Router,
  { render: function (props) {
      return _react2['default'].createElement(_reduxAsyncConnect.ReduxAsyncConnect, _extends({}, props, { helpers: { client: client }, filter: function (item) {
          return !item.deferred;
        } }));
    }, history: syncedHistory, onUpdate: logPageView },
  _routes2['default'](store)
);

_reactDom2['default'].render(_react2['default'].createElement(
  _reactRedux.Provider,
  { store: store, key: 'provider' },
  component
), dest);

if (process.env.NODE_ENV !== 'production') {
  window.React = _react2['default']; // enable debugger

  if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
    console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
  }
}

if (__DEVTOOLS__ && !window.devToolsExtension) {
  var DevTools = require('./containers/DevTools/DevTools');
  _reactDom2['default'].render(_react2['default'].createElement(
    _reactRedux.Provider,
    { store: store, key: 'provider' },
    _react2['default'].createElement(
      'div',
      null,
      component,
      _react2['default'].createElement(DevTools, null)
    )
  ), dest);
}


//////////////////
// WEBPACK FOOTER
// ./src/client.js
// module id = 662
// module chunks = 0